export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const MAIN_DOMAIN = process.env.REACT_APP_MAIN_DOMAIN;

export const courseStatuses = {
    NOT_STARTED: "not_started",
    COMPLETED: "completed",
    IN_PROGRESS: "in_progress",
}